module.exports = __webpack_public_path__ + "static/img/cont43_03.1bbf3b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_03.jpg
// module id = WSm9
// module chunks = 0